<template>
  <v-row>
    <v-col cols="12">
      <base-card>
        <v-row>
          <v-col cols="9" md="11"
            ><v-card-title
              >Yearly Sales Table <span>({{ betweenDate }})</span></v-card-title
            ></v-col
          >
          <v-col cols="3" md="1">
            <v-dialog ref="dialog" v-model="modal" persistent width="300">
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" class="mt-3" icon>
                  <v-icon>mdi-calendar</v-icon>
                </v-btn>
              </template>

              <v-card>
                <v-card-title class="headline">
                   Select Year Range
                </v-card-title>

                <v-card-text>
                  <v-select
                    v-model="startYear"
                    :items="yearOptions"
                    label="Start Year"
                    outlined
                    dense
                  ></v-select>

                  <v-select
                    v-model="endYear"
                    :items="endYearOptions"
                    label="End Year"
                    outlined
                    dense
                  ></v-select>

                  <div
                    v-if="startYear && endYear && endYear < startYear"
                    class="error--text text-caption mt-2"
                  >
                    End year must be equal or greater than start year.
                  </div>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    :disabled="!startYear || !endYear || endYear < startYear"
                    @click="saveYearRange"
                  >
                    {{ $t("salesSummaryPage.choose") }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>

        <div class="d-flex align-center justify-space-between pr-3 mt-n10">
          <v-card-title>
            <v-select
              class="mt-8"
              v-model="selectBranch"
              :items="branchList"
              item-text="name"
              item-value="branch_id"
              outlined
              dense
            ></v-select
          ></v-card-title>
          <v-spacer></v-spacer>
          <div v-if="salesList.length != 0">
            <export-excel
              :data="salesListToPrint"
              :fields="json_fields"
              :name="filename"
            >
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on"> mdi-download </v-icon>
                </template>
                <span
                  >{{ $t("dailySalesPage.downloadDailySalesReport") }}
                </span>
              </v-tooltip>
            </export-excel>
          </div>
        </div>
        <v-card-text class="mt-n7">
          <v-data-table
            :headers="headers"
            :items="salesList"
            :page.sync="page"
            :no-data-text="$t('dailyModifierSalesPage.noData')"
            :items-per-page="itemsPerPage"
            @page-count="pageCount = $event"
            item-key="sales_id"
          >
            <template v-slot:item.charge="{ item }">
              <span v-if="item.charge != null && item.charge != ''">{{
                item.charge
              }}</span>
              <span v-else>0.00</span>
            </template>
          </v-data-table>
        </v-card-text>
      </base-card>
    </v-col>
  </v-row>
</template>
  <script>
import { BASEURL } from "@/api/baseurl";
import axios from "axios";
import TestCard from "@/components/card/TestCard";
import PriceCard from "@/components/card/PriceCard";
import VueHtml2pdf from "vue-html2pdf";

export default {
  name: "Sales",
  metaInfo: {
    // title will be injected into parent titleTemplate
    title: "Sales",
  },
  components: {
    "test-card": TestCard,
    "price-card": PriceCard,
    VueHtml2pdf,
  },
  data() {
    const currentYear = new Date().getFullYear();
    return {
      json_fields: {
        Branch: "name",
        Year: "year",
        "Gross Sales": "grossSales",
        "Discount amount": "promotion",
        Charge: {
          field: "charge",
          callback: (value) => {
            if (value != "") {
              return value;
            } else {
              return "0.00";
            }
          },
        },
        "Net Sales": "netsales",
        Tax: "tax",
        Rouding: "rounding",
        Sales: "total_amount",
      },
      domain: BASEURL,
      company_id: "",
      showIcon: false,
      showChart: false,
      betweenDate: "",
      // year picker
      modal: false,
      startYear: currentYear,
      endYear: currentYear,
      yearOptions: [],
      // end
      branchList: [],
      salesList: [],
      selectBranch: "",
      salesListToPrint: [],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,

      //chart
      series: [
        {
          name: "Sales",
          data: [],
        },
      ],
      chartOptions: {
        chart: {
          height: 300,
          width: 600,
          type: "line",
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          type: "Date/Month/Year",
        },
      },
    };
  },
  computed: {
    filename() {
      return "Monthly Sales Report_" + this.betweenDate + ".xls";
    },
    endYearOptions() {
      // Only allow end years >= selected start year
      return this.yearOptions.filter(
        (year) => !this.startYear || year >= this.startYear
      );
    },
    headers() {
      return [
        {
          text: this.$t("salesSummaryPage.branch"),
          align: "start",
          sortable: false,
          value: "name",
        },

        {
          text: "Year",
          align: "start",
          value: "year",
          sortable: false,
        },

        {
          text: this.$t("dailySalesPage.salesAmount"),
          align: "start",
          sortable: false,
          value: "total_amount",
        },

        {
          text: "Rounding",
          align: "start",
          sortable: false,
          value: "rounding",
        },

        {
          text: this.$t("dailySalesPage.tax"),
          align: "start",
          value: "tax",
          sortable: false,
        },

        {
          text: this.$t("dailySalesPage.charge"),
          align: "start",
          value: "charge",
          sortable: false,
        },

        {
          text: this.$t("dailySalesPage.promotion"),
          align: "start",
          value: "promotion",
          sortable: false,
        },

        {
          text: this.$t("salesSummaryPage.grossSales"),
          align: "start",
          value: "grossSales",
          sortable: false,
        },

        {
          text: this.$t("dailySalesPage.netSales"),
          align: "start",
          value: "netsales",
          sortable: false,
        },
      ];
    },
  },
  watch: {
    selectBranch() {
      this.salesList = [];
      this.getAllSettlement();
    },
  },
  mounted() {
    const currentYear = new Date().getFullYear();
    const startFrom = currentYear - 20;
    this.yearOptions = Array.from({ length: 21 }, (_, i) => startFrom + i);
  },

  created() {
    var CryptoJS = require("crypto-js");
    var x = localStorage.getItem("userInfo");
    // Decrypt
    var bytes = CryptoJS.AES.decrypt(x, "secret key 123");
    var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    this.companyID = decryptedData.company_id;
    this.getCompanyBranch();
  },
  methods: {
    getAllSettlement() {
      this.betweenDate = this.startYear + " - " + this.endYear;
      const params = new URLSearchParams();
      params.append("getSalePerYearList", "done");
      params.append("branch_id", this.selectBranch);
      params.append("start", this.startYear);
      params.append("end", this.endYear);
      axios({
        method: "post",
        url: this.domain + "/report/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);

          if (response.data.status == "1") {
            // this.series = [
            //   {
            //     name: "Sales",
            //     data: [],
            //   },
            // ];
            this.salesList = response.data.report;
            // this.showChart = true;
            // var currentMonthDates = Array(
            //   moment(this.date, "YYYY-MM").daysInMonth()
            // )
            //   .fill(null)
            //   .map((x, i) => moment(this.date).startOf("month").add(i, "days"));

            // for (let i = 0; i < currentMonthDates.length; i++) {
            //   var obj = { x: "", y: "" };
            //   obj.x = moment(currentMonthDates[i]).format("DD-MM-YYYY");
            //   obj.y = 0.0;
            //   this.series[0].data.push(obj);
            // }

            // for (let j = 0; j < this.salesList.length; j++) {
            //   const index = this.series[0].data.findIndex((obj) => {
            //     return (
            //       obj.x === moment(this.salesList[j].date).format("DD-MM-YYYY")
            //     );
            //   });
            //   this.series[0].data[index].x = moment(
            //     this.salesList[j].date
            //   ).format("DD-MM-YYYY");
            //   this.series[0].data[index].y = this.salesList[j].total_amount;
            // }

            this.salesListToPrint = [...this.salesList];

            const totalSalesAmountSum = this.salesListToPrint.reduce(
              (sum, entry) => sum + parseFloat(entry.total_amount) || 0,
              0
            );

            const totalRoundingSum = this.salesListToPrint.reduce(
              (sum, entry) => sum + parseFloat(entry.rounding) || 0,
              0
            );

            const totalTaxSum = this.salesListToPrint.reduce(
              (sum, entry) => sum + parseFloat(entry.tax) || 0,
              0
            );

            const totalChargeSum = this.salesListToPrint.reduce(
              (sum, entry) => sum + parseFloat(entry.charge) || 0,
              0
            );

            const totalPromotionSum = this.salesListToPrint.reduce(
              (sum, entry) => sum + parseFloat(entry.promotion) || 0,
              0
            );

            const totalGrossSalesSum = this.salesListToPrint.reduce(
              (sum, entry) => sum + parseFloat(entry.grossSales) || 0,
              0
            );

            const totalNetSalesSum = this.salesListToPrint.reduce(
              (sum, entry) => sum + parseFloat(entry.netsales) || 0,
              0
            );

            // Clone the original data structure but empty other fields
            const summedData = {
              total_amount: totalSalesAmountSum.toFixed(2),
              charge: totalChargeSum.toFixed(2),
              tax: totalTaxSum.toFixed(2),
              rounding: totalRoundingSum.toFixed(2),
              netsales: totalNetSalesSum.toFixed(2),
              promotion: totalPromotionSum.toFixed(2),
              grossSales: totalGrossSalesSum.toFixed(2),
              name: "Total",
            };

            this.salesListToPrint.push(summedData);
          } else {
            this.salesList = [];
            // this.series = [
            //   {
            //     name: "Sales",
            //     data: [],
            //   },
            // ];
            // var moment = require("moment");
            // var currentMonthDates = new Array(
            //   moment(this.date, "YYYY-MM").daysInMonth()
            // )
            //   .fill(null)
            //   .map((x, i) =>
            //     moment(this.date, "YYYY-MM").startOf("month").add(i, "days")
            //   );

            // for (let w = 0; w < currentMonthDates.length; w++) {
            //   var obj = { x: "", y: "" };
            //   obj.x = moment(currentMonthDates[w]).format("DD-MM-YYYY");
            //   obj.y = 0.0;
            //   this.series[0].data.push(obj);
            // }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    saveYearRange() {
      const selectedRange = {
        start: this.startYear,
        end: this.endYear,
      };
      this.$refs.dialog.save(selectedRange);
      this.modal = false;
      this.getAllSettlement()
    },

    getCompanyBranch() {
      const params = new URLSearchParams();
      params.append("getCompanyBranch", "done");
      params.append("company_id", this.companyID);

      axios({
        method: "post",
        url: this.domain + "/branch/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.status == "1") {
            this.branchList = response.data.branch;
            this.selectBranch = this.branchList[0].branch_id;
            this.getAllSettlement();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

  
  
  